import { useResizeObserver } from '@vueuse/core'
import { debounce } from 'lodash-es'
import { watch, onMounted, ref, type Ref } from 'vue'

export function useElementHeightResize(
  toolbarWrapper: Ref<HTMLElement | null>,
  calculateWrapperHeight: (height: number) => string,
) {
  const windowHeight = ref(window.innerHeight)
  const wrapperHeight = ref<string>('')

  function handleResize() {
    const { height } = toolbarWrapper.value?.getBoundingClientRect() || { height: 0 }
    wrapperHeight.value = calculateWrapperHeight(height)
  }

  onMounted(() => {
    handleResize()
    window.addEventListener('resize', debounce(handleResize, 100))
  })

  useResizeObserver(toolbarWrapper, (entries) => {
    const entry = entries[0]
    const { height } = entry.contentRect
    wrapperHeight.value = calculateWrapperHeight(height)
  })

  watch(windowHeight, debounce(handleResize, 100))

  return { wrapperHeight }
}
